import React from 'react';

import {
  BaseWidget,
  LabelledText,
  PermissionWall,
  activityTemplates,
  layout,
  widgets
} from 'modules';

import { useParams } from 'react-router-dom';
import * as dataService from './dataService';



export const ReturnAuthorizationDetailActivity: React.FC = () => {
  const params = useParams<{ returnAuthorizationId: string; }>();
  const queryTuple = dataService.useQuery(params.returnAuthorizationId ?? '');

  return queryTuple.data.storeId ? (
    <activityTemplates.AdminActivityTemplate.FC>
      <layout.ColumnBox>
        <layout.RowBox>
          <widgets.returnAuthorization.ActionsWidget.FC
            storeId={queryTuple.data.storeId}
            returnAuthorizationId={params.returnAuthorizationId ?? ''} />
        </layout.RowBox>

        <layout.RowBox>
          <layout.ColumnBox>
            <layout.RowBox>
              <PermissionWall.FC
                storeId={queryTuple.data.storeId}
                requiresPermissions={['inventory_viewProduct']}>
                <widgets.returnAuthorization.ReturnedProductsWidget.FC returnAuthorizationId={params.returnAuthorizationId ?? ''} />
              </PermissionWall.FC>
            </layout.RowBox>

            <layout.RowBox>
              <widgets.returnAuthorization.SummaryWidget.FC returnAuthorizationId={params.returnAuthorizationId ?? ''} />

              <widgets.order.CustomerInformationWidget.FC
                orderId={queryTuple.data.orderId}
                storeId={queryTuple.data.storeId} />
            </layout.RowBox>

            <layout.RowBox>
              <PermissionWall.FC
                storeId={queryTuple.data.storeId}
                requiresPermissions={['customer_viewCustomer']}>
                <BaseWidget.FC title="Customer Information">
                  <LabelledText.FC
                    title="Full Name"
                    text={queryTuple.data.customer?.fullName ?? 'N/A'} />

                  <LabelledText.FC
                    title="Email"
                    text={queryTuple.data.customer?.email ?? ''} />

                  <LabelledText.FC
                    title="Phone Number"
                    text={queryTuple.data.customer?.phoneNumber ?? 'N/A'} />
                </BaseWidget.FC>
              </PermissionWall.FC>

              <widgets.returnAuthorization.ReturnShippingWidget.FC returnAuthorizationId={params.returnAuthorizationId ?? ''} />
            </layout.RowBox>
          </layout.ColumnBox>

          <widgets.returnAuthorization.LifeCycleWidget.FC
            variant="partner"
            storeId={queryTuple.data.storeId}
            returnAuthorizationId={params.returnAuthorizationId ?? ''} />
        </layout.RowBox>

        <layout.RowBox>
          <PermissionWall.FC requiresPermissions={['itemReceipt_view']}>
            <widgets.returnAuthorization.ItemReceiptWidget.FC returnAuthorizationId={params.returnAuthorizationId ?? ''} />
          </PermissionWall.FC>
        </layout.RowBox>

        {/* messages */}
        <layout.RowBox>
          <widgets.common.PartnerChatWidget.FC
            storeId={queryTuple.data.storeId}
            returnAuthorizationId={params.returnAuthorizationId ?? ''} />
        </layout.RowBox>

        {/* Audit log */}
        <layout.RowBox>
          <widgets.common.AuditLogWidget.FC
            storeId={queryTuple.data.storeId}
            returnAuthorizationId={params.returnAuthorizationId ?? ''} />
        </layout.RowBox>
      </layout.ColumnBox>
    </activityTemplates.AdminActivityTemplate.FC>
  ) : null;
};
